import React, { useState, useRef, useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import { DownloadIcon, Employee, Eye, Filter, Active, Office, SearchBig, DeleteDustbin } from "../AllSvg";
import { formatDate, formatDateTime, formattedDateLong } from "../Date";
import { BASE_URL, IMAGE_URL, TESTING_URL } from "../../config/axios";
import { customSortByKey, downloadAsExcel, formatCurrencyIndian, formatRoundoff2D, handleAllError, handleErrorToast, ViewChatImageorFile, DateRangePicker, CustomTooltip, ButtonVariants } from "../CustomFunctions";
import { useLocation, useNavigate } from "react-router-dom";

import { DownloadTableExcel } from "react-export-table-to-excel";
import usePermission from "../../config/permissions";
import Loader from "../Loader";

const ImprestCustomReport = () => {

    const location = useLocation();
    let filters_employee = location.state?.filter_employee !== null ? location.state?.filter_employee : 'null';
    let filters_department = location.state?.filter_department !== null ? location.state?.filter_department : `${sessionStorage.getItem("department")}`;
    let filters_subCompany = location.state?.filter_subCompany !== null ? location.state?.filter_subCompany : `${sessionStorage.getItem("company_id")}`;
    let filters_empstatus = location.state?.filter_empstatus !== null ? location.state?.filter_empstatus : 'active';


    const [imprestDateSorting, setImprestDateSorting] = useState("null");
    const [imprestAmountSorting, setImprestAmountSorting] = useState("null");
    const [expenseDateSorting, setExpenseDateSorting] = useState("null");
    const [expenseAmountSorting, setExpenseAmountSorting] = useState("null");

    const [selectedEmployee, setSelectedEmployee] = useState(sessionStorage.getItem('emp_code'));
    const [selectedProject, setSelectedProject] = useState('');
    const [employeeGet, setEmployeeGet] = useState(filters_employee || 'null');
    const [selectedDepartment, setSelectedDepartment] = useState(filters_department || 'null');
    const [selectedSubCompany, setSelectedSubCompany] = useState(filters_subCompany || `${sessionStorage.getItem("company_id")}`);
    const [active, setActive] = useState(filters_empstatus || 'active');


    const [fromdate, setFromDate] = useState('null');
    const [todate, setToDate] = useState('null');
    const [datetimefield, setDateTimeField] = useState('date');


    const [dates, setDates] = useState(0)
    // setDates(res.data.map(item => item.date).sort((a, b) => new Date(a) - new Date(b)));
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(false); //buffering logic
    const [imprestExpenseData, setImprestExpenseData] = useState([]);
    const [filteredImprestExpenseData, setfilteredImprestExpenseData] = useState([]);

    const getImprestExpenseData = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
            const res = await axios.get(
                // `${TESTING_URL}/wfm/expenseadminapprovedcustomdata/${employeeGet}/${selectedDepartment}/null/${active}/approved/${fromdate}/${todate}/`
                `${BASE_URL}/wfm/expensecustomdatawithupdatedatefileds/${employeeGet}/${selectedDepartment}/${selectedSubCompany}/${active}/approved/${fromdate}/${todate}/${datetimefield}/`
                // `${BASE_URL}/wfm/expensecustomdatawithupdatedatefileds/CIPL578/null/null/null/null/null/null/date/`
            );

            // setImprestExpenseData(res.data);

            let filteredData = res.data;


            // Sorting logic for Imprest
            switch (imprestDateSorting) {
                case "asc_date":
                    filteredData = filteredData.sort((a, b) => new Date(a.date) - new Date(b.date));
                    break;
                case "desc_date":
                    filteredData = filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
                    break;
                case "asc_bill":
                    filteredData = filteredData.sort((a, b) => new Date(a.account_update_datetime) - new Date(b.account_update_datetime));
                    break;
                case "desc_bill":
                    filteredData = filteredData.sort((a, b) => new Date(b.account_update_datetime) - new Date(a.account_update_datetime));
                    break;
                default:
                    filteredData = filteredData
                    break;
            }

            // Sorting logic for Imprest Amount
            switch (imprestAmountSorting) {
                case "asc_amount":
                    filteredData = filteredData.sort((a, b) => {
                        const amountA = calculateTotalAmount(a);
                        const amountB = calculateTotalAmount(b);
                        return amountA - amountB; // Ascending order
                    });
                    break;
                case "desc_amount":
                    filteredData = filteredData.sort((a, b) => {
                        const amountA = calculateTotalAmount(a);
                        const amountB = calculateTotalAmount(b);
                        return amountB - amountA; // Descending order
                    });
                    break;
                default:
                    filteredData = filteredData
                    break;
            }

            // Sorting logic for Expense
            switch (expenseDateSorting) {
                case "asc_date":
                    filteredData = filteredData.sort((a, b) => {
                        const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
                        const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
                        return aDate - bDate;
                    });
                    break;
                case "desc_date":
                    filteredData = filteredData.sort((a, b) => {
                        const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
                        const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
                        return bDate - aDate;
                    });
                    break;
                case "asc_bill":
                    filteredData = filteredData.sort((a, b) => {
                        const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                        const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                        const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
                        const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
                        return aFirstDate - bFirstDate;
                    });
                    break;
                case "desc_bill":
                    filteredData = filteredData.sort((a, b) => {
                        const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                        const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                        const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
                        const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
                        return bFirstDate - aFirstDate;
                    });
                    break;
                case "asc_settlement":
                    filteredData = filteredData.sort((a, b) => {
                        const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
                        const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
                        return aDate - bDate;
                    });
                    break;
                case "desc_settlement":
                    filteredData = filteredData.sort((a, b) => {
                        const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
                        const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
                        return bDate - aDate;
                    });
                    break;
                default:
                    filteredData = filteredData;
                    break;
            }
            // Sorting logic for Imprest Amount
            switch (expenseAmountSorting) {
                case "asc_amount":
                    filteredData = filteredData.sort((a, b) => {
                        const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
                        const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
                        return aAmount - bAmount;
                    });
                    break;
                case "desc_amount":
                    filteredData = filteredData.sort((a, b) => {
                        const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
                        const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
                        return bAmount - aAmount;
                    });
                    break;
                default:
                    filteredData = filteredData
                    break;
            }

            setImprestExpenseData(filteredData);
            setfilteredImprestExpenseData(filteredData);
            // setImprestExpenseData(res.data);

        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };


    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err)
        }
    };

    useEffect(() => {
        getImprestExpenseData();
    }, [fromdate, todate, datetimefield, employeeGet, selectedDepartment, selectedSubCompany, active, selectedDepartment,
        imprestDateSorting, imprestAmountSorting, expenseDateSorting, expenseAmountSorting]);


    const [allemployee, setAllemployee] = useState([]);
    const [departmentLists, setDepartmentLists] = useState([]);
    const getFilterData = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedSubCompany}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setAllemployee(sortedList);
            const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${sessionStorage.getItem('company_id') || 'null'}/active/`);
            setDepartmentLists(dep.data);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };


    useEffect(() => {
        getFilterData();
        getSubCompany();
    }, [active, selectedSubCompany]);

    const options = allemployee
        .sort((a, b) => a.emp_code - b.emp_code)
        .map((i) => ({
            value: i.emp_code,
            label: `${i.emp_code} - ${i.name}`,
        }));

    const nullOption = { value: 'null', label: 'Select Employee Code' };

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            // Set selected employee code(s)
            setEmployeeGet(selectedOption.value);
        } else {
            setEmployeeGet(null); // Clear selection
        }
    };
    const handleImprestDateSortChange = (e) => setImprestDateSorting(e.target.value);
    const handleImprestAmountSortChange = (e) => setImprestAmountSorting(e.target.value);
    const handleExpenseDateSortChange = (e) => setExpenseDateSorting(e.target.value);
    const handleExpenseAmountSortChange = (e) => setExpenseAmountSorting(e.target.value);


    const applyFilters = () => {
        let filteredData = imprestExpenseData;

        if (selectedProject !== '') {
            const lowercaseSelectedProject = selectedProject.toLowerCase();
            filteredData = filteredData.filter((data) => {
                const nameMatch = data.ref_project_name?.toLowerCase().includes(lowercaseSelectedProject);
                const codeMatch = data.ref_project_code?.toString().includes(selectedProject);
                return nameMatch || codeMatch;
            });
        }

        setfilteredImprestExpenseData(filteredData);
    };

    // Helper function to calculate the total amount for an item
    const calculateTotalAmount = (item) => {
        if (item.rh_leave_status === "approved") {
            return (
                Number(item.approved_transportation) +
                Number(item.approved_accomodation) +
                Number(item.approved_fooding) +
                (item.other_details?.length > 0
                    ? item.other_details.reduce(
                        (total, other) => total + Number(other.approved_other || 0),
                        0
                    )
                    : 0)
            );
        } else {
            return (
                Number(item.transportation) +
                Number(item.accomodation) +
                Number(item.fooding) +
                (item.other_details?.length > 0
                    ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
                    : 0)
            );
        }
    };

    useEffect(() => {
        applyFilters();
    }, [imprestExpenseData, selectedProject]);

    const tableRef = useRef(null);
    const handleDownloadExcel = () => {
        downloadAsExcel(tableRef, "Data", `CustomData`);
    };


    return (
        <>
            <div className="content-tabs">
                <div className="attendance-history-cont">
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            <div className="field-cont-div">
                                {/* <Employee /> */}
                                {buffer1 ?
                                    <div className="align-center form-loader">
                                        <div className="bar-loader"></div>
                                    </div>
                                    :
                                    <>
                                        <Employee />
                                        <Select
                                            className="attendance-input-field width-20vw"
                                            width="200px"
                                            options={[nullOption, ...options]} // Include "null" option at the beginning
                                            value={options.find(option => option.value === employeeGet) || nullOption}  // Ensure the correct option is selected
                                            placeholder="Select Employee Code"
                                            onChange={handleChange}
                                            isClearable
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    color: '#707070',
                                                    outline: 'none',
                                                    border: 'none',
                                                    padding: '0.6rem 0.5rem',
                                                    textTransform: 'capitalize',
                                                    boxShadow: 'none',
                                                    '&:hover': {
                                                        border: 'none',
                                                    },
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#707070',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#707070',
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    filter: 'invert(50%)',
                                                    cursor: 'pointer',
                                                    left: '9.5rem',
                                                    width: '20px',
                                                    height: '20px',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999, // Ensure dropdown menu appears above other elements
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    color: state.isSelected ? '#2576bc' : '#707070',
                                                    backgroundColor: state.isSelected ? 'rgba(37,118,188,0.1)' : 'white',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        backgroundColor: '#2576bc',
                                                        color: 'white',
                                                    },
                                                }),
                                            }}
                                        />
                                    </>}
                                <hr className="field-cont-hr" />
                            </div>

                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={datetimefield}
                                    onChange={(e) => setDateTimeField(e.target.value)}
                                >
                                    <option value="date">Expense Date</option>
                                    <option value="rh_update_datetime">RH Update Datetime</option>
                                    <option value="admin_update_datetime">Admin Update Datetime</option>
                                    <option value="account_update_datetime">Account Update Datetime</option>
                                    <option value="final_update_datetime">Final Update Datetime</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>

                            {/* <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="From Date"
                                    type="date"
                                    value={fromdate}
                                    onChange={(e) => setFromDate(e.target.value || null)}
                                />
                            </div>

                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="To Date"
                                    type="date"
                                    value={todate}
                                    onChange={(e) => setToDate(e.target.value || null)}
                                />
                            </div>
                            <hr className="field-cont-hr" />
                        </div> */}

                            <div className="field-cont-div">
                                <Active />
                                <select
                                    className="attendance-input-field width-10vw"
                                    type="text"
                                    value={active}
                                    onChange={(e) => setActive(e.target.value)}
                                >
                                    <option value="null">All</option>
                                    <option value="active">Active</option>
                                    <option value="inactive">In Active</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={selectedSubCompany}
                                    onChange={(e) => setSelectedSubCompany(e.target.value)}
                                >
                                    {/* <option value="">All Sub Companies</option> */}
                                    {SubCompany.sort((a, b) => a.title - b.title).map((i, index) => (
                                        <option value={i.id}>{i.title}</option>
                                    ))}
                                    ;
                                </select>
                                <hr className="field-cont-hr" />
                            </div>

                            <DateRangePicker
                                startDate={fromdate}
                                endDate={todate}
                                onChange={(start, end) => {
                                    setFromDate(start);
                                    setToDate(end);
                                }}
                                className="width-10vw"
                                showPresets={true}
                            />


                        </div>
                        <div className="btn-cont">
                            {/* <div className="btn-cont">
                        <button className=" model-button-print" title="Download in Excel Format" onClick={handleDownloadExcel}>
                            <DownloadIcon />
                        </button>
                    </div> */}
                            <hr className="field-cont-hr" />
                            <DownloadTableExcel
                                filename={`Expense Data ${fromdate === todate ? `${fromdate}` : `${fromdate} to ${todate}`} ${datetimefield}`}
                                sheet="Details"
                                currentTableRef={tableRef.current}
                            >
                                <button className="model-button   font-weight500   model-button-print">
                                    <DownloadIcon />
                                </button>
                            </DownloadTableExcel>
                        </div>
                    </div>

                    <div className="table-css-white-background-new scroll-container-table">
                        <table ref={tableRef} className="">
                            <thead
                                style={{
                                    position: "sticky",
                                    top: "0",
                                    backgroundColor: "#fff",
                                    zIndex: "10",
                                }}
                            >
                                <tr className="custom-table-head-tr-0P">
                                    <th className="table-heading">S. No.</th>
                                    <th className="table-heading">Project Reference</th>
                                    <th className="table-heading" style={{ textAlign: "center" }}>Employee Code</th>
                                    <th className="table-heading" style={{ textAlign: "center" }}>Employee Name</th>
                                    <th className="table-heading">Date</th>
                                    <th className="table-heading">Expense <b>Against</b> Imprest</th>
                                    <th className="table-heading" style={{ textAlign: "center" }}>Imprest Amount</th>
                                    <th className="table-heading" style={{ textAlign: "center" }}>Expense Amount</th>
                                    <th className="table-heading">Utilized Money</th>
                                    <th className="table-heading">Remaining Money</th>
                                    <th className="table-heading">Status</th>
                                    <th className="table-heading">RH Status</th>
                                    <th className="table-heading">Account Status</th>
                                    <th className="table-heading">Admin Status</th>
                                    <th className="table-heading">Final Status</th>
                                    <th className="table-heading width-15vw">Remarks</th>
                                    {/* <th className="table-heading">View/Action</th> */}
                                </tr>
                            </thead>
                            {/* {buffer ? <div className="spinner"></div> :
                            <tbody>
                                {filteredImprestExpenseData?.map((i, index) => {
                                    let foodingTotal = 0
                                    let approvedFoodingTotal = 0
                                    let transportationTotal = 0
                                    let approvedTransportationTotal = 0
                                    let accomodationTotal = 0
                                    let approvedAccomodationTotal = 0
                                    let otherTotal = 0
                                    let approvedOtherTotal = 0

                                    i.expense_details?.forEach(item => {
                                        const amount = parseFloat(item.item_amount);
                                        const approvedAmount = parseFloat(item.bill_approved_amt);
                                        switch (item.expense_type) {
                                            case 'fooding':
                                                foodingTotal += amount
                                                approvedFoodingTotal += approvedAmount
                                                break;
                                            case 'transportation':
                                                transportationTotal += amount
                                                approvedTransportationTotal += approvedAmount
                                                break;
                                            case 'accomodation':
                                                accomodationTotal += amount
                                                approvedAccomodationTotal += approvedAmount
                                                break;

                                            default:
                                                otherTotal += amount
                                                approvedOtherTotal += approvedAmount
                                                break;
                                        }
                                    });

                                    return (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="8"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="table-body">{index + 1}</td>

                                                <td className="table-body">
                                                    {i.imprest_data?.project_id ?
                                                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="table-body" >Project Code</td>
                                                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right word-wrap-20vw">
                                                                        {i.imprest_data?.ref_project_code}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-body" >Project Name</td>
                                                                    <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right word-wrap-20vw">
                                                                        {i.imprest_data?.ref_project_name}
                                                                    </td>
                                                                </tr>

                                                            </tbody>
                                                        </table> :
                                                        <div className="align-center justify-center">
                                                            - No Project Referenced -
                                                        </div>
                                                    }
                                                </td>

                                                <td className="table-body" style={{ textAlign: "center" }}>
                                                    <p>{i.empcode}</p>
                                                </td>
                                                <td className="table-body" style={{ textAlign: "center" }}>
                                                    <p>{i.emp_name}</p>
                                                </td>
                                                <td className="table-body">{formatDate(i.date)}</td>
                                                <td className="table-body width-5vw"><span>{i.name}</span>
                                                    <br />
                                                    <b> Against </b>
                                                    <br />
                                                    <span className="word-wrap-10vw">{i.project_name}</span>
                                                </td>
                                                <td className="table-body">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Transportation</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(i.approved_transportation || 0)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Accommodation</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(i.approved_accomodation || 0)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Food</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(i.approved_fooding || 0)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <b>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Others</td>
                                                                </b>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    <b>
                                                                        {formatCurrencyIndian(
                                                                            i?.imprest_details?.reduce(
                                                                                (sum, other) => sum + Number(other.approved_other || 0),
                                                                                0
                                                                            )
                                                                        )}
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                            {i.imprest_details?.length > 0 ? (
                                                                <>
                                                                    {i.imprest_details.map((other, index) => (
                                                                        <tr key={index}>
                                                                            <td className="table-body word-wrap-10vw" style={{ paddingLeft: "5px", paddingBottom: "5px" }} >
                                                                                {other.other_name ? other.other_name : `Other-${index + 1}`}
                                                                            </td>
                                                                            <td style={{ padding: "0px 4px" }}>:</td>
                                                                            <td className="align-right">
                                                                                {formatCurrencyIndian(other.approved_other || 0)}
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                </>
                                                            ) : (
                                                                <tr>
                                                                    <td style={{ padding: "0px 4px", paddingBottom: "5px" }} colSpan={3}>No Other Expense</td>
                                                                </tr>
                                                            )}
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>
                                                                    <b>Total</b>
                                                                </td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    <b>
                                                                        {formatCurrencyIndian(
                                                                            Number(i.approved_transportation) +
                                                                            Number(i.approved_accomodation) +
                                                                            Number(i.approved_fooding) +
                                                                            (i.imprest_details?.length > 0
                                                                                ? i.imprest_details.reduce(
                                                                                    (total, other) => total + Number(other.approved_other || 0),
                                                                                    0
                                                                                )
                                                                                : 0)
                                                                        )}
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td className="table-body">
                                                    <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Final Transportation</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(approvedTransportationTotal || 0)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Final Accommodation</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(approvedAccomodationTotal || 0)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>Final Food</td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    {formatCurrencyIndian(approvedFoodingTotal || 0)}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <b>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Final Others</td>
                                                                </b>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    <b>
                                                                        {formatCurrencyIndian(approvedOtherTotal || 0)}
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <td className="table-body" style={{ paddingBottom: "5px" }}>
                                                                    <b>Final Total</b>
                                                                </td>
                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                <td className="align-right">
                                                                    <b>
                                                                        {formatCurrencyIndian(
                                                                            Number(approvedFoodingTotal || 0) +
                                                                            Number(approvedTransportationTotal || 0) +
                                                                            Number(approvedAccomodationTotal || 0) +
                                                                            Number(approvedOtherTotal || 0)
                                                                        )}
                                                                    </b>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                                <td className="table-body align-center">{i.utilized_amount ? formatRoundoff2D(i.utilized_amount) : '-'} Rs</td>
                                                <td className="table-body align-center">{i.remaining_amount ? formatRoundoff2D(i.remaining_amount) : '-'} Rs</td>
                                                <td className="table-body">
                                                    <span
                                                        request-status={i.rh_status}
                                                        className="request-status align-center"
                                                        title={i.rh_status === "rejected" ? `Rh Reject Reason : ${i.rh_rejection_reason}` : ""}
                                                    >
                                                        {i.rh_status === "pending"
                                                            ? "Pending For Rh Approval ⌛"
                                                            : i.rh_status === "rejected"
                                                                ? "Rh ✖, "
                                                                : "Rh ✔, "}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={i.account_status_a}
                                                        className="request-status align-center"
                                                        title={i.account_status_a === "rejected" ? `Account Reject Reason : ${i.account1_rejection_reason}` : ""}
                                                    >
                                                        {i.rh_status === "rejected" &&
                                                            i.admin_status === "rejected" &&
                                                            i.account_status_a === "rejected"
                                                            ? "Account ✖, "
                                                            : i.rh_status === "approved" &&
                                                                i.admin_status === "approved" &&
                                                                i.account_status_a === "pending"
                                                                ? "Pending For Account Approval ⌛"
                                                                : i.rh_status === "approved" &&
                                                                    i.admin_status === "approved" &&
                                                                    i.account_status_a === "rejected"
                                                                    ? "Accounts ✖, "
                                                                    : i.rh_status === "approved" &&
                                                                        i.admin_status === "approved" &&
                                                                        i.account_status_a === "approved"
                                                                        ? "Accounts ✔, "
                                                                        : "Accounts Stage 1: " + i.account_status_a}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={i.admin_status}
                                                        className="request-status align-center"
                                                        title={i.admin_status === "rejected" ? `Admin Reject Reason : ${i.admin_rejection_reason}` : ""}
                                                    >
                                                        {i.rh_status === "rejected" &&
                                                            i.admin_status === "rejected"
                                                            ? "Admin ✖, "
                                                            : i.rh_status === "approved" &&
                                                                i.admin_status === "pending"
                                                                ? "Pending For Admin Approval ⌛,"
                                                                : i.rh_status === "approved" &&
                                                                    i.admin_status === "rejected"
                                                                    ? "Admin ✖, "
                                                                    : i.rh_status === "approved" &&
                                                                        i.admin_status === "approved"
                                                                        ? "Admin ✔, "
                                                                        : "Admin Status: " + i.admin_status}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={i.account_status_b}
                                                        className="request-status align-center"
                                                    >
                                                        {i.rh_status === "rejected" &&
                                                            i.admin_status === "rejected" &&
                                                            i.account_status_b === "rejected"
                                                            ? "Account ✖, "
                                                            : i.rh_status === "approved" &&
                                                                i.admin_status === "approved" &&
                                                                i.account_status_b === "pending"
                                                                ? "Pending For Account Approval ⌛"
                                                                : i.rh_status === "approved" &&
                                                                    i.admin_status === "approved" &&
                                                                    i.account_status_b === "rejected"
                                                                    ? "Accounts ✖, "
                                                                    : i.rh_status === "approved" &&
                                                                        i.admin_status === "approved" &&
                                                                        i.account_status_b === "approved"
                                                                        ? "Accounts ✔, "
                                                                        : "Accounts Stage 2: " + i.account_status_b}
                                                    </span>
                                                </td>
                                                <td request-status={i.rh_status} className="request-status table-body align-center">{i.rh_status}</td>
                                                <td request-status={i.account_status_a} className="request-status table-body align-center">{i.account_status_a}</td>
                                                <td request-status={i.admin_status} className="request-status table-body align-center">{i.admin_status}</td>
                                                <td request-status={i.account_status_b} className="request-status table-body align-center">{i.account_status_b}</td>
                                                <td title="Remarks and Approval Dates" className="table-body">
                                                    <span
                                                        request-status={i.rh_status}
                                                        className="request-status "
                                                    >
                                                        {i.rh_status === "pending"
                                                            ? "-"
                                                            : i.rh_status === "rejected"
                                                                ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                                                                : `Rh${i.rh_assigned ? `(${i.rh_assigned}-${i.rh_assigned_name}) ` : ''}: Verified Amounts for Bills ${i.rh_update_datetime ? `At: ${formatDateTime(i.rh_update_datetime).date}` : ''}`}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={i.account_status_a}
                                                        className="request-status "
                                                    >
                                                        {i.account_status_a === "pending"
                                                            ? "-"
                                                            : i.account_status_a === "rejected"
                                                                ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                                                                : `Accounts${i.account_update_by ? `(${i.account_update_by}-${i.account_update_by_name || ''}) ` : ''}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ''}`}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={i.admin_status}
                                                        className="request-status "
                                                        title={i.admin_status === "rejected" ? `Admin Reject Reason : ${i.admin_rejection_reason}` : ""}
                                                    >
                                                        {i.admin_status === "pending"
                                                            ? "-"
                                                            : i.admin_status === "rejected"
                                                                ? `Admin Rejection Reason : ${i.admin_rejection_reason}`
                                                                : `Admin${i.admin_update_by ? `(${i.admin_update_by}-${i.admin_update_by_name || ''}) ` : ''}: Approved After Final Verification  ${i.admin_update_datetime ? `At: ${formatDateTime(i.admin_update_datetime).date}` : ''}`}
                                                    </span>
                                                    <br />
                                                    <span
                                                        request-status={i.account_status_b}
                                                        className="request-status "
                                                    >
                                                        {i.account_status_b === "pending"
                                                            ? "-"
                                                            : i.account_status_b === "rejected"
                                                                ? `Final Rejection Reason : ${i.account2_rejection_reason}`
                                                                : `Final${i.final_update_by ? `(${i.final_update_by}-${i.final_update_by || ''}) ` : ''}: Approved And Settled ${i.final_update_datetime ? `At: ${formatDateTime(i.final_update_datetime).date}` : ''}`}
                                                    </span>
                                                </td>

                                            </tr>
                                        </React.Fragment>
                                    )
                                }
                                )}
                            </tbody>
                        } */}
                        </table>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const ExpenseCustomReport = () => {

    const location = useLocation();
    let filters_employee = location.state?.filter_employee !== null ? location.state?.filter_employee : 'null';
    let filters_department = location.state?.filter_department !== null ? location.state?.filter_department : `${sessionStorage.getItem("department")}`;
    let filters_subCompany = location.state?.filter_subCompany !== null ? location.state?.filter_subCompany : `${sessionStorage.getItem("company_id")}`;
    let filters_empstatus = location.state?.filter_empstatus !== null ? location.state?.filter_empstatus : 'active';
    let filters_admin_status = location.state?.filters_admin_status !== null ? location.state?.filters_admin_status : 'approved';

    const { SUPER_ADMIN } = usePermission();

    const [imprestDateSorting, setImprestDateSorting] = useState("null");
    const [imprestAmountSorting, setImprestAmountSorting] = useState("null");
    const [expenseDateSorting, setExpenseDateSorting] = useState("null");
    const [expenseAmountSorting, setExpenseAmountSorting] = useState("null");

    const [selectedEmployee, setSelectedEmployee] = useState(sessionStorage.getItem('emp_code'));
    const [selectedProject, setSelectedProject] = useState('');
    const [employeeGet, setEmployeeGet] = useState(filters_employee || 'null');
    const [selectedDepartment, setSelectedDepartment] = useState(filters_department || 'null');
    const [selectedSubCompany, setSelectedSubCompany] = useState(filters_subCompany || `${sessionStorage.getItem("company_id")}`);
    const [active, setActive] = useState(filters_empstatus || 'active');


    const [adminStatus, setAdminStatus] = useState(filters_admin_status || 'approved');
    const [fromdate, setFromDate] = useState('null');
    const [todate, setToDate] = useState('null');
    const [datetimefield, setDateTimeField] = useState('date');


    const [dates, setDates] = useState(0)
    // setDates(res.data.map(item => item.date).sort((a, b) => new Date(a) - new Date(b)));
    const [buffer, setBuffering] = useState(true); //buffering logic
    const [buffer1, setBuffering1] = useState(false); //buffering logic
    const [imprestExpenseData, setImprestExpenseData] = useState([]);
    const [filteredImprestExpenseData, setfilteredImprestExpenseData] = useState([]);

    const getImprestExpenseData = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            // const res = await axios.get(`${BASE_URL}/wfm/expense/${selectedStatus}/${fromdate}/${todate}/${employeeGet}/`);
            const res = await axios.get(
                // `${TESTING_URL}/wfm/expenseadminapprovedcustomdata/${employeeGet}/${selectedDepartment}/null/${active}/approved/${fromdate}/${todate}/`
                `${BASE_URL}/wfm/expensecustomdatawithupdatedatefileds/${employeeGet}/${selectedDepartment}/${selectedSubCompany}/${active}/${adminStatus}/${fromdate}/${todate}/${datetimefield}/`
                // `${BASE_URL}/wfm/expensecustomdatawithupdatedatefileds/CIPL578/null/null/null/null/null/null/date/`
            );

            // setImprestExpenseData(res.data);

            let filteredData = res.data;


            // Sorting logic for Imprest
            switch (imprestDateSorting) {
                case "asc_date":
                    filteredData = filteredData.sort((a, b) => new Date(a.date) - new Date(b.date));
                    break;
                case "desc_date":
                    filteredData = filteredData.sort((a, b) => new Date(b.date) - new Date(a.date));
                    break;
                case "asc_bill":
                    filteredData = filteredData.sort((a, b) => new Date(a.account_update_datetime) - new Date(b.account_update_datetime));
                    break;
                case "desc_bill":
                    filteredData = filteredData.sort((a, b) => new Date(b.account_update_datetime) - new Date(a.account_update_datetime));
                    break;
                default:
                    filteredData = filteredData
                    break;
            }

            // Sorting logic for Imprest Amount
            switch (imprestAmountSorting) {
                case "asc_amount":
                    filteredData = filteredData.sort((a, b) => {
                        const amountA = calculateTotalAmount(a);
                        const amountB = calculateTotalAmount(b);
                        return amountA - amountB; // Ascending order
                    });
                    break;
                case "desc_amount":
                    filteredData = filteredData.sort((a, b) => {
                        const amountA = calculateTotalAmount(a);
                        const amountB = calculateTotalAmount(b);
                        return amountB - amountA; // Descending order
                    });
                    break;
                default:
                    filteredData = filteredData
                    break;
            }

            // Sorting logic for Expense
            switch (expenseDateSorting) {
                case "asc_date":
                    filteredData = filteredData.sort((a, b) => {
                        const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
                        const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
                        return aDate - bDate;
                    });
                    break;
                case "desc_date":
                    filteredData = filteredData.sort((a, b) => {
                        const aDate = a.expense_data?.[0]?.date ? new Date(a.expense_data[0].date) : new Date(0);
                        const bDate = b.expense_data?.[0]?.date ? new Date(b.expense_data[0].date) : new Date(0);
                        return bDate - aDate;
                    });
                    break;
                case "asc_bill":
                    filteredData = filteredData.sort((a, b) => {
                        const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                        const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                        const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
                        const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
                        return aFirstDate - bFirstDate;
                    });
                    break;
                case "desc_bill":
                    filteredData = filteredData.sort((a, b) => {
                        const aDatesList = a.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                        const bDatesList = b.expense_data?.[0]?.expense_details?.map(exp => new Date(exp.date)).sort((x, y) => x - y) || [];
                        const aFirstDate = aDatesList.length ? aDatesList[0] : new Date(0);
                        const bFirstDate = bDatesList.length ? bDatesList[0] : new Date(0);
                        return bFirstDate - aFirstDate;
                    });
                    break;
                case "asc_settlement":
                    filteredData = filteredData.sort((a, b) => {
                        const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
                        const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
                        return aDate - bDate;
                    });
                    break;
                case "desc_settlement":
                    filteredData = filteredData.sort((a, b) => {
                        const aDate = a.expense_data?.[0]?.final_update_datetime ? new Date(a.expense_data[0].final_update_datetime) : new Date(0);
                        const bDate = b.expense_data?.[0]?.final_update_datetime ? new Date(b.expense_data[0].final_update_datetime) : new Date(0);
                        return bDate - aDate;
                    });
                    break;
                default:
                    filteredData = filteredData;
                    break;
            }
            // Sorting logic for Imprest Amount
            switch (expenseAmountSorting) {
                case "asc_amount":
                    filteredData = filteredData.sort((a, b) => {
                        const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
                        const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
                        return aAmount - bAmount;
                    });
                    break;
                case "desc_amount":
                    filteredData = filteredData.sort((a, b) => {
                        const aAmount = a.expense_data?.[0]?.utilized_amount ? Number(a.expense_data[0].utilized_amount) : 0;
                        const bAmount = b.expense_data?.[0]?.utilized_amount ? Number(b.expense_data[0].utilized_amount) : 0;
                        return bAmount - aAmount;
                    });
                    break;
                default:
                    filteredData = filteredData
                    break;
            }

            setImprestExpenseData(filteredData);
            setfilteredImprestExpenseData(filteredData);
            // setImprestExpenseData(res.data);

        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering(false);// End Buffering
        }
    };


    const [SubCompany, setSubCompany] = useState([]);

    const getSubCompany = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/wfm/subcompany/`);
            setSubCompany(res.data);
        } catch (err) {
            handleErrorToast(err)
        }
    };

    useEffect(() => {
        getImprestExpenseData();
    }, [fromdate, todate, datetimefield, employeeGet, selectedDepartment, selectedSubCompany, active, adminStatus, selectedDepartment,
        imprestDateSorting, imprestAmountSorting, expenseDateSorting, expenseAmountSorting]);


    const [allemployee, setAllemployee] = useState([]);
    const [departmentLists, setDepartmentLists] = useState([]);
    const getFilterData = async () => {
        setBuffering1(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetails/${active}/${selectedSubCompany}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setAllemployee(sortedList);
            const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${sessionStorage.getItem('company_id') || 'null'}/active/`);
            setDepartmentLists(dep.data);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering1(false); //buffering logic // End Buffering
        }
    };


    useEffect(() => {
        getFilterData();
        getSubCompany();
    }, [active, selectedSubCompany]);

    const options = allemployee
        .sort((a, b) => a.emp_code - b.emp_code)
        .map((i) => ({
            value: i.emp_code,
            label: `${i.emp_code} - ${i.name}`,
        }));

    const nullOption = { value: 'null', label: 'Select Employee Code' };

    const handleChange = (selectedOption) => {
        if (selectedOption) {
            // Set selected employee code(s)
            setEmployeeGet(selectedOption.value);
        } else {
            setEmployeeGet(null); // Clear selection
        }
    };
    const handleImprestDateSortChange = (e) => setImprestDateSorting(e.target.value);
    const handleImprestAmountSortChange = (e) => setImprestAmountSorting(e.target.value);
    const handleExpenseDateSortChange = (e) => setExpenseDateSorting(e.target.value);
    const handleExpenseAmountSortChange = (e) => setExpenseAmountSorting(e.target.value);


    const applyFilters = () => {
        let filteredData = imprestExpenseData;

        if (selectedProject !== '') {
            const lowercaseSelectedProject = selectedProject.toLowerCase();
            filteredData = filteredData.filter((data) => {
                const nameMatch = data.ref_project_name?.toLowerCase().includes(lowercaseSelectedProject);
                const codeMatch = data.ref_project_code?.toString().includes(selectedProject);
                return nameMatch || codeMatch;
            });
        }

        setfilteredImprestExpenseData(filteredData);
    };

    // Helper function to calculate the total amount for an item
    const calculateTotalAmount = (item) => {
        if (item.rh_leave_status === "approved") {
            return (
                Number(item.approved_transportation) +
                Number(item.approved_accomodation) +
                Number(item.approved_fooding) +
                (item.other_details?.length > 0
                    ? item.other_details.reduce(
                        (total, other) => total + Number(other.approved_other || 0),
                        0
                    )
                    : 0)
            );
        } else {
            return (
                Number(item.transportation) +
                Number(item.accomodation) +
                Number(item.fooding) +
                (item.other_details?.length > 0
                    ? item.other_details.reduce((total, other) => total + Number(other.amount || 0), 0)
                    : 0)
            );
        }
    };

    useEffect(() => {
        applyFilters();
    }, [imprestExpenseData, selectedProject]);

    const tableRef = useRef(null);
    const handleDownloadExcel = () => {
        downloadAsExcel(tableRef, "Data", `CustomData`);
    };


    return (
        <>
            <div className="content-tabs">
                <div className="attendance-history-cont">
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            <div className="field-cont-div">

                                {SUPER_ADMIN ? <div className="field-cont-div">
                                    <Office />
                                    <select
                                        className="attendance-input-field width-10vw   date-field"
                                        type="text"
                                        value={selectedSubCompany}
                                        onChange={(e) => setSelectedSubCompany(e.target.value)}
                                    >
                                        {/* <option value="">All Sub Companies</option> */}
                                        {SubCompany.sort((a, b) => a.title - b.title).map((i, index) => (
                                            <option value={i.id}>{i.title}</option>
                                        ))}
                                    </select>
                                    <hr className="field-cont-hr" />
                                </div> : null}

                                <div className="field-cont-div">
                                    <Active />
                                    <select
                                        className="attendance-input-field width-10vw"
                                        type="text"
                                        value={active}
                                        onChange={(e) => setActive(e.target.value)}
                                    >
                                        <option value="null">All</option>
                                        <option value="active">Active</option>
                                        <option value="inactive">In Active</option>
                                    </select>
                                    <hr className="field-cont-hr" />
                                </div>

                                {/* <Employee /> */}
                                {buffer1 ?
                                    <div className="align-center form-loader">
                                        <div className="bar-loader"></div>
                                    </div>
                                    :
                                    <>
                                        <Employee />
                                        <Select
                                            className="attendance-input-field width-20vw"
                                            width="200px"
                                            options={[nullOption, ...options]} // Include "null" option at the beginning
                                            value={options.find(option => option.value === employeeGet) || nullOption}  // Ensure the correct option is selected
                                            placeholder="Select Employee Code"
                                            onChange={handleChange}
                                            isClearable
                                            styles={{
                                                control: (provided) => ({
                                                    ...provided,
                                                    color: '#707070',
                                                    outline: 'none',
                                                    border: 'none',
                                                    padding: '0.6rem 0.5rem',
                                                    textTransform: 'capitalize',
                                                    boxShadow: 'none',
                                                    '&:hover': {
                                                        border: 'none',
                                                    },
                                                }),
                                                singleValue: (provided) => ({
                                                    ...provided,
                                                    color: '#707070',
                                                }),
                                                placeholder: (provided) => ({
                                                    ...provided,
                                                    color: '#707070',
                                                }),
                                                dropdownIndicator: (provided) => ({
                                                    ...provided,
                                                    filter: 'invert(50%)',
                                                    cursor: 'pointer',
                                                    left: '9.5rem',
                                                    width: '20px',
                                                    height: '20px',
                                                }),
                                                menu: (provided) => ({
                                                    ...provided,
                                                    zIndex: 9999, // Ensure dropdown menu appears above other elements
                                                }),
                                                option: (provided, state) => ({
                                                    ...provided,
                                                    color: state.isSelected ? '#2576bc' : '#707070',
                                                    backgroundColor: state.isSelected ? 'rgba(37,118,188,0.1)' : 'white',
                                                    cursor: 'pointer',
                                                    '&:hover': {
                                                        backgroundColor: '#2576bc',
                                                        color: 'white',
                                                    },
                                                }),
                                            }}
                                        />
                                    </>}
                                <hr className="field-cont-hr" />
                            </div>

                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw   date-field"
                                    type="text"
                                    value={datetimefield}
                                    onChange={(e) => setDateTimeField(e.target.value)}
                                >
                                    <option value="date">Expense Date</option>
                                    <option value="rh_update_datetime">RH Update Datetime</option>
                                    <option value="admin_update_datetime">Admin Update Datetime</option>
                                    <option value="account_update_datetime">Account Update Datetime</option>
                                    <option value="final_update_datetime">Final Update Datetime</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>

                            {/* <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="From Date"
                                    type="date"
                                    value={fromdate}
                                    onChange={(e) => setFromDate(e.target.value || null)}
                                />
                            </div>

                            <hr className="field-cont-hr" />
                        </div>

                        <div className="field-cont-div">
                            <div className="date-uppercase ">
                                <input
                                    className="attendance-input-field width-10vw   date-field date-field-filter"
                                    placeholder="To Date"
                                    type="date"
                                    value={todate}
                                    onChange={(e) => setToDate(e.target.value || null)}
                                />
                            </div>
                            <hr className="field-cont-hr" />
                        </div> */}



                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw"
                                    type="text"
                                    value={adminStatus}
                                    onChange={(e) => setAdminStatus(e.target.value)}
                                >
                                    <option value="null">All Admin Status</option>
                                    <option value="pending">Admin Pending</option>
                                    <option value="approved">Admin Approved</option>
                                    <option value="rejected">Admin Rejected</option>
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <DateRangePicker
                                startDate={fromdate}
                                endDate={todate}
                                onChange={(start, end) => {
                                    setFromDate(start);
                                    setToDate(end);
                                }}
                                className="width-10vw"
                                showPresets={true}
                            />


                        </div>
                        <div className="btn-cont">
                            {/* <div className="btn-cont">
                        <button className=" model-button-print" title="Download in Excel Format" onClick={handleDownloadExcel}>
                            <DownloadIcon />
                        </button>
                    </div> */}
                            <hr className="field-cont-hr" />
                            <DownloadTableExcel
                                filename={`Expense Data ${fromdate === todate ? `${fromdate}` : `${fromdate} to ${todate}`} ${datetimefield}`}
                                sheet="Details"
                                currentTableRef={tableRef.current}
                            >
                                <button className="model-button   font-weight500   model-button-print">
                                    <DownloadIcon />
                                </button>
                            </DownloadTableExcel>
                        </div>
                    </div>

                    <div className="table-css-white-background-new scroll-container-table">
                        <table ref={tableRef} className="">
                            <thead
                                style={{
                                    position: "sticky",
                                    top: "0",
                                    backgroundColor: "#fff",
                                    zIndex: "10",
                                }}
                            >
                                <tr className="custom-table-head-tr-0P">
                                    <th className="table-heading">S. No.</th>
                                    <th className="table-heading">Project Reference</th>
                                    <th className="table-heading" style={{ textAlign: "center" }}>Employee Code</th>
                                    <th className="table-heading" style={{ textAlign: "center" }}>Employee Name</th>
                                    <th className="table-heading">Date</th>
                                    <th className="table-heading">Expense <b>Against</b> Imprest</th>
                                    <th className="table-heading" style={{ textAlign: "center" }}>Imprest Amount</th>
                                    <th className="table-heading" style={{ textAlign: "center" }}>Expense Amount</th>
                                    <th className="table-heading">Utilized Money</th>
                                    <th className="table-heading">Remaining Money</th>
                                    <th className="table-heading">Status</th>
                                    <th className="table-heading">RH Status</th>
                                    <th className="table-heading">Account Status</th>
                                    <th className="table-heading">Admin Status</th>
                                    <th className="table-heading">Final Status</th>
                                    <th className="table-heading width-15vw">Remarks</th>
                                    {/* <th className="table-heading">View/Action</th> */}
                                </tr>
                            </thead>
                            {buffer ? <div className="spinner"></div> : //buffering logic
                                <tbody>
                                    {filteredImprestExpenseData?.map((i, index) => {
                                        let foodingTotal = 0
                                        let approvedFoodingTotal = 0
                                        let transportationTotal = 0
                                        let approvedTransportationTotal = 0
                                        let accomodationTotal = 0
                                        let approvedAccomodationTotal = 0
                                        let otherTotal = 0
                                        let approvedOtherTotal = 0

                                        i.expense_details?.forEach(item => {
                                            const amount = parseFloat(item.item_amount);
                                            const approvedAmount = parseFloat(item.bill_approved_amt);
                                            switch (item.expense_type) {
                                                case 'fooding':
                                                    foodingTotal += amount
                                                    approvedFoodingTotal += approvedAmount
                                                    break;
                                                case 'transportation':
                                                    transportationTotal += amount
                                                    approvedTransportationTotal += approvedAmount
                                                    break;
                                                case 'accomodation':
                                                    accomodationTotal += amount
                                                    approvedAccomodationTotal += approvedAmount
                                                    break;

                                                default:
                                                    otherTotal += amount
                                                    approvedOtherTotal += approvedAmount
                                                    break;
                                            }
                                        });

                                        return (
                                            <React.Fragment key={index}>
                                                <tr className="tr-border-bottom">
                                                    <td colSpan="8"></td>
                                                </tr>
                                                <tr className="custom-table-head-td">
                                                    <td className="table-body">{index + 1}</td>

                                                    <td className="table-body">
                                                        {i.imprest_data?.project_id ?
                                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="table-body" >Project Code</td>
                                                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                        <td className="align-right word-wrap-20vw">
                                                                            {i.imprest_data?.ref_project_code}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="table-body" >Project Name</td>
                                                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                        <td className="align-right word-wrap-20vw">
                                                                            {i.imprest_data?.ref_project_name}
                                                                        </td>
                                                                    </tr>

                                                                </tbody>
                                                            </table> :
                                                            <div className="align-center justify-center">
                                                                - No Project Referenced -
                                                            </div>
                                                        }
                                                    </td>

                                                    <td className="table-body" style={{ textAlign: "center" }}>
                                                        <p>{i.empcode}</p>
                                                    </td>
                                                    <td className="table-body" style={{ textAlign: "center" }}>
                                                        <p>{i.emp_name}</p>
                                                    </td>
                                                    <td className="table-body">{formatDate(i.date)}</td>
                                                    <td className="table-body width-5vw"><span>{i.name}</span>
                                                        <br />
                                                        <b> Against </b>
                                                        <br />
                                                        <span className="word-wrap-10vw">{i.project_name}</span>
                                                    </td>
                                                    <td className="table-body">
                                                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Transportation</td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {formatCurrencyIndian(i.approved_transportation || 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Accommodation</td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {formatCurrencyIndian(i.approved_accomodation || 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Food</td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {formatCurrencyIndian(i.approved_fooding || 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <b>
                                                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Others</td>
                                                                    </b>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        <b>
                                                                            {formatCurrencyIndian(
                                                                                i?.imprest_details?.reduce(
                                                                                    (sum, other) => sum + Number(other.approved_other || 0),
                                                                                    0
                                                                                )
                                                                            )}
                                                                        </b>
                                                                    </td>
                                                                </tr>
                                                                {i.imprest_details?.length > 0 ? (
                                                                    <>
                                                                        {i.imprest_details.map((other, index) => (
                                                                            <tr key={index}>
                                                                                <td className="table-body word-wrap-10vw" style={{ paddingLeft: "5px", paddingBottom: "5px" }} >
                                                                                    {other.other_name ? other.other_name : `Other-${index + 1}`}
                                                                                </td>
                                                                                <td style={{ padding: "0px 4px" }}>:</td>
                                                                                <td className="align-right">
                                                                                    {formatCurrencyIndian(other.approved_other || 0)}
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </>
                                                                ) : (
                                                                    <tr>
                                                                        <td style={{ padding: "0px 4px", paddingBottom: "5px" }} colSpan={3}>No Other Expense</td>
                                                                    </tr>
                                                                )}
                                                                <tr>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>
                                                                        <b>Total</b>
                                                                    </td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        <b>
                                                                            {formatCurrencyIndian(
                                                                                Number(i.approved_transportation) +
                                                                                Number(i.approved_accomodation) +
                                                                                Number(i.approved_fooding) +
                                                                                (i.imprest_details?.length > 0
                                                                                    ? i.imprest_details.reduce(
                                                                                        (total, other) => total + Number(other.approved_other || 0),
                                                                                        0
                                                                                    )
                                                                                    : 0)
                                                                            )}
                                                                        </b>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td className="table-body">
                                                        <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Final Transportation</td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {formatCurrencyIndian(approvedTransportationTotal || 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Final Accommodation</td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {formatCurrencyIndian(approvedAccomodationTotal || 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>Final Food</td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        {formatCurrencyIndian(approvedFoodingTotal || 0)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <b>
                                                                        <td className="table-body" style={{ paddingBottom: "5px" }}>Final Others</td>
                                                                    </b>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        <b>
                                                                            {formatCurrencyIndian(approvedOtherTotal || 0)}
                                                                        </b>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td className="table-body" style={{ paddingBottom: "5px" }}>
                                                                        <b>Final Total</b>
                                                                    </td>
                                                                    <td style={{ padding: "0px 4px" }}>:</td>
                                                                    <td className="align-right">
                                                                        <b>
                                                                            {formatCurrencyIndian(
                                                                                Number(approvedFoodingTotal || 0) +
                                                                                Number(approvedTransportationTotal || 0) +
                                                                                Number(approvedAccomodationTotal || 0) +
                                                                                Number(approvedOtherTotal || 0)
                                                                            )}
                                                                        </b>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                    <td className="table-body align-center">{i.utilized_amount ? formatRoundoff2D(i.utilized_amount) : '-'} Rs</td>
                                                    <td className="table-body align-center">{i.remaining_amount ? formatRoundoff2D(i.remaining_amount) : '-'} Rs</td>
                                                    <td className="table-body">
                                                        <span
                                                            request-status={i.rh_status}
                                                            className="request-status align-center"
                                                            title={i.rh_status === "rejected" ? `Rh Reject Reason : ${i.rh_rejection_reason}` : ""}
                                                        >
                                                            {i.rh_status === "pending"
                                                                ? "Pending For Rh Approval ⌛"
                                                                : i.rh_status === "rejected"
                                                                    ? "Rh ✖, "
                                                                    : "Rh ✔, "}
                                                        </span>
                                                        <br />
                                                        <span
                                                            request-status={i.account_status_a}
                                                            className="request-status align-center"
                                                            title={i.account_status_a === "rejected" ? `Account Reject Reason : ${i.account1_rejection_reason}` : ""}
                                                        >
                                                            {i.rh_status === "rejected" &&
                                                                i.admin_status === "rejected" &&
                                                                i.account_status_a === "rejected"
                                                                ? "Account ✖, "
                                                                : i.rh_status === "approved" &&
                                                                    i.admin_status === "approved" &&
                                                                    i.account_status_a === "pending"
                                                                    ? "Pending For Account Approval ⌛"
                                                                    : i.rh_status === "approved" &&
                                                                        i.admin_status === "approved" &&
                                                                        i.account_status_a === "rejected"
                                                                        ? "Accounts ✖, "
                                                                        : i.rh_status === "approved" &&
                                                                            i.admin_status === "approved" &&
                                                                            i.account_status_a === "approved"
                                                                            ? "Accounts ✔, "
                                                                            : "Accounts Stage 1: " + i.account_status_a}
                                                        </span>
                                                        <br />
                                                        <span
                                                            request-status={i.admin_status}
                                                            className="request-status align-center"
                                                            title={i.admin_status === "rejected" ? `Admin Reject Reason : ${i.admin_rejection_reason}` : ""}
                                                        >
                                                            {i.rh_status === "rejected" &&
                                                                i.admin_status === "rejected"
                                                                ? "Admin ✖, "
                                                                : i.rh_status === "approved" &&
                                                                    i.admin_status === "pending"
                                                                    ? "Pending For Admin Approval ⌛,"
                                                                    : i.rh_status === "approved" &&
                                                                        i.admin_status === "rejected"
                                                                        ? "Admin ✖, "
                                                                        : i.rh_status === "approved" &&
                                                                            i.admin_status === "approved"
                                                                            ? "Admin ✔, "
                                                                            : "Admin Status: " + i.admin_status}
                                                        </span>
                                                        <br />
                                                        <span
                                                            request-status={i.account_status_b}
                                                            className="request-status align-center"
                                                        >
                                                            {i.rh_status === "rejected" &&
                                                                i.admin_status === "rejected" &&
                                                                i.account_status_b === "rejected"
                                                                ? "Account ✖, "
                                                                : i.rh_status === "approved" &&
                                                                    i.admin_status === "approved" &&
                                                                    i.account_status_b === "pending"
                                                                    ? "Pending For Account Approval ⌛"
                                                                    : i.rh_status === "approved" &&
                                                                        i.admin_status === "approved" &&
                                                                        i.account_status_b === "rejected"
                                                                        ? "Accounts ✖, "
                                                                        : i.rh_status === "approved" &&
                                                                            i.admin_status === "approved" &&
                                                                            i.account_status_b === "approved"
                                                                            ? "Accounts ✔, "
                                                                            : "Accounts Stage 2: " + i.account_status_b}
                                                        </span>
                                                    </td>
                                                    <td request-status={i.rh_status} className="request-status table-body align-center">{i.rh_status}</td>
                                                    <td request-status={i.account_status_a} className="request-status table-body align-center">{i.account_status_a}</td>
                                                    <td request-status={i.admin_status} className="request-status table-body align-center">{i.admin_status}</td>
                                                    <td request-status={i.account_status_b} className="request-status table-body align-center">{i.account_status_b}</td>
                                                    <td title="Remarks and Approval Dates" className="table-body">
                                                        <span
                                                            request-status={i.rh_status}
                                                            className="request-status "
                                                        >
                                                            {i.rh_status === "pending"
                                                                ? "-"
                                                                : i.rh_status === "rejected"
                                                                    ? `Rh Reject Reason : ${i.rh_rejection_reason}`
                                                                    : `Rh${i.rh_assigned ? `(${i.rh_assigned}-${i.rh_assigned_name}) ` : ''}: Verified Amounts for Bills ${i.rh_update_datetime ? `At: ${formatDateTime(i.rh_update_datetime).date}` : ''}`}
                                                        </span>
                                                        <br />
                                                        <span
                                                            request-status={i.account_status_a}
                                                            className="request-status "
                                                        >
                                                            {i.account_status_a === "pending"
                                                                ? "-"
                                                                : i.account_status_a === "rejected"
                                                                    ? `Accounts Reject Reason : ${i.account1_rejection_reason}`
                                                                    : `Accounts${i.account_update_by ? `(${i.account_update_by}-${i.account_update_by_name || ''}) ` : ''}: Bills Verified ${i.account_update_datetime ? `At: ${formatDateTime(i.account_update_datetime).date}` : ''}`}
                                                        </span>
                                                        <br />
                                                        <span
                                                            request-status={i.admin_status}
                                                            className="request-status "
                                                            title={i.admin_status === "rejected" ? `Admin Reject Reason : ${i.admin_rejection_reason}` : ""}
                                                        >
                                                            {i.admin_status === "pending"
                                                                ? "-"
                                                                : i.admin_status === "rejected"
                                                                    ? `Admin Rejection Reason : ${i.admin_rejection_reason}`
                                                                    : `Admin${i.admin_update_by ? `(${i.admin_update_by}-${i.admin_update_by_name || ''}) ` : ''}: Approved After Final Verification  ${i.admin_update_datetime ? `At: ${formatDateTime(i.admin_update_datetime).date}` : ''}`}
                                                        </span>
                                                        <br />
                                                        <span
                                                            request-status={i.account_status_b}
                                                            className="request-status "
                                                        >
                                                            {i.account_status_b === "pending"
                                                                ? "-"
                                                                : i.account_status_b === "rejected"
                                                                    ? `Final Rejection Reason : ${i.account2_rejection_reason}`
                                                                    : `Final${i.final_update_by ? `(${i.final_update_by}-${i.final_update_by || ''}) ` : ''}: Approved And Settled ${i.final_update_datetime ? `At: ${formatDateTime(i.final_update_datetime).date}` : ''}`}
                                                        </span>
                                                    </td>
                                                    {/* <td className="table-body align-center">
                                            <button
                                                className="allproject-dashboard"
                                                title="View using Navigate"
                                                onClick={(e) => openExenseSlip(i)}
                                            >
                                                <Eye />
                                            </button>
                                        </td> */}
                                                </tr>
                                            </React.Fragment>
                                        )
                                    }
                                    )}
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const EmployeeHeadcountCustomReport = () => {
    const location = useLocation();

    const { SUB_COMPANIES, SUPER_ADMIN } = usePermission();

    // Get initial filters from location state or session storage
    let filters_subCompany = location.state?.filter_subCompany !== null ? location.state?.filter_subCompany : `${sessionStorage.getItem("company_id")}`;

    const [selectedSubCompany, setSelectedSubCompany] = useState(filters_subCompany || `${sessionStorage.getItem("company_id")}`);
    // const [startMonth, setStartMonth] = useState('1');
    const [startMonth, setStartMonth] = useState((new Date().getMonth() + 1).toString());
    const [startYear, setStartYear] = useState(new Date().getFullYear().toString());
    const [endMonth, setEndMonth] = useState((new Date().getMonth() + 1).toString());
    const [endYear, setEndYear] = useState(new Date().getFullYear().toString());

    const [buffer, setBuffering] = useState(true);
    const [headcountData, setHeadcountData] = useState([]);
    const [filteredHeadcountData, setFilteredHeadcountData] = useState([]);


    // Get current date for max limit
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const currentMonthYear = `${currentYear}-${currentMonth.toString().padStart(2, '0')}`;

    // Format values for min/max attributes
    const startDateValue = `${startYear}-${startMonth.padStart(2, '0')}`;
    const endDateValue = `${endYear}-${endMonth.padStart(2, '0')}`;

    // Get headcount data from API
    const getHeadcountData = async () => {
        setBuffering(true);
        try {
            const payload = {
                start_month: startMonth,
                start_year: startYear,
                end_month: endMonth,
                end_year: endYear
            };

            const res = await axios.post(
                `${BASE_URL}/wfm/monthly-report-employeecount-bysubcompany-withempstatuscount/${selectedSubCompany}/`,
                payload
            );

            setHeadcountData(res.data);
            setFilteredHeadcountData(res.data);
        } catch (err) {
            handleAllError(err);
        } finally {
            setBuffering(false);
        }
    };

    // Get subcompany list

    useEffect(() => {
        getHeadcountData();
    }, [selectedSubCompany, startMonth, startYear, endMonth, endYear]);


    // Generate year options (current year and previous 5 years)
    const yearOptions = Array.from({ length: 6 }, (_, i) => {
        const year = new Date().getFullYear() - i;
        return { value: year.toString(), label: year.toString() };
    });

    const tableRef = useRef(null);

    const handleDownloadExcel = () => {
        downloadAsExcel(tableRef, "EmployeeHeadcountData", `Employee_Headcount_Report_${startMonth}_${startYear}_to_${endMonth}_${endYear}`);
    };

    return (
        <>
            <div className="content-tabs">
                <div className="attendance-history-cont">
                    <div className="attendance-subcont">
                        <div className="field-cont">
                            {/* Sub Company Filter */}
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    type="text"
                                    value={selectedSubCompany}
                                    onChange={(e) => setSelectedSubCompany(e.target.value)}
                                >
                                    {SUB_COMPANIES.sort((a, b) => a.title - b.title).map((i, index) => (
                                        <option key={i.id} value={i.id}>{i.title}</option>
                                    ))}
                                </select>
                                <hr className="field-cont-hr" />
                            </div>


                            {/* Start Month-Year Filter */}
                            <div className="field-cont-div">
                                <Filter />
                                <input
                                    type="month"
                                    className="attendance-input-field width-15vw date-field"
                                    value={startDateValue}
                                    max={endDateValue} // Start date cannot be after end date
                                    onChange={(e) => {
                                        const value = e.target.value; // Format: "YYYY-MM"
                                        if (value) {
                                            const [year, month] = value.split('-');
                                            setStartYear(year);
                                            setStartMonth(month.replace(/^0+/, '')); // Remove leading zeros for payload
                                        }
                                    }}
                                />
                                <hr className="field-cont-hr" />
                            </div>

                            {/* End Month-Year Filter */}
                            <div className="field-cont-div">
                                <Filter />
                                <input
                                    type="month"
                                    className="attendance-input-field width-15vw date-field"
                                    value={endDateValue}
                                    min={startDateValue} // End date cannot be before start date
                                    max={currentMonthYear} // End date cannot be in the future
                                    onChange={(e) => {
                                        const value = e.target.value; // Format: "YYYY-MM"
                                        if (value) {
                                            const [year, month] = value.split('-');
                                            setEndYear(year);
                                            setEndMonth(month.replace(/^0+/, '')); // Remove leading zeros for payload
                                        }
                                    }}
                                />
                                <hr className="field-cont-hr" />
                            </div>

                            {/* <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    value={endMonth}
                                    onChange={(e) => setEndMonth(e.target.value)}
                                >
                                    {monthOptions.map(month => (
                                        <option key={month.value} value={month.value}>
                                            {month.label}
                                        </option>
                                    ))}
                                </select>
                                <hr className="field-cont-hr" />
                            </div>

                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-10vw date-field"
                                    value={endYear}
                                    onChange={(e) => setEndYear(e.target.value)}
                                >
                                    {yearOptions.map(year => (
                                        <option key={year.value} value={year.value}>
                                            {year.label}
                                        </option>
                                    ))}
                                </select>
                                <hr className="field-cont-hr" />
                            </div> */}
                        </div>

                        <div className="btn-cont">
                            <hr className="field-cont-hr" />
                            <DownloadTableExcel
                                filename={`Employee_Headcount_Report_${startMonth}_${startYear}_to_${endMonth}_${endYear}`}
                                sheet="EmployeeHeadcount"
                                currentTableRef={tableRef.current}
                            >
                                <button className="model-button font-weight500 model-button-print">
                                    <DownloadIcon />
                                </button>
                            </DownloadTableExcel>
                        </div>
                    </div>

                    {/* Updated table structure to match LetterTemplatesTable */}
                    <div className="table-css-white-background">
                        <table ref={tableRef} className="table-css">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    <th className="align-left">S.No</th>
                                    <th className="align-center">Month</th>
                                    <th className="align-center">Sub Company</th>
                                    <th className="align-center">Start of Month</th>
                                    <th className="align-center">Onboarding in Month</th>
                                    <th className="align-center">Leaving in Month</th>
                                    <th className="align-center">End of Month</th>
                                </tr>
                            </thead>
                            {buffer ? <div className="spinner"></div> :
                                <tbody>
                                    {filteredHeadcountData?.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <tr className="tr-border-bottom">
                                                <td colSpan="7"></td>
                                            </tr>
                                            <tr className="custom-table-head-td">
                                                <td className="align-left">{index + 1}</td>
                                                <td className="align-center">{item.month_year}</td>
                                                <td className="align-center">{item.sub_company_name}</td>
                                                <td className="align-center">
                                                    <CustomTooltip
                                                        position="top"
                                                        tooltipContent={
                                                            <div>
                                                                <div>Active Employees: <strong>{item.start_of_month.active}</strong></div>
                                                                <div>Inactive Employees: <strong>{item.start_of_month.inactive}</strong></div>
                                                                <div>Total Employees: <strong>{item.start_of_month.total}</strong></div>
                                                            </div>
                                                        }
                                                    >
                                                        <span style={{ cursor: 'help', textDecoration: 'underline', color: '#007bff' }}>
                                                            {item.start_of_month.total}
                                                        </span>
                                                    </CustomTooltip>
                                                    {item.start_of_month.total > 0 && <EmployeeMonthlyDetailsTable sub_company={item.sub_company} month={item.month} year={item.year} type={"start_of_month"} SUB_COMPANIES={SUB_COMPANIES} />}
                                                </td>
                                                <td className="align-center">
                                                    <CustomTooltip
                                                        position="top"
                                                        tooltipContent={
                                                            <div>
                                                                <div>Active Employees: <strong>{item.onboarding_in_month.active}</strong></div>
                                                                <div>Inactive Employees: <strong>{item.onboarding_in_month.inactive}</strong></div>
                                                                <div>Total Employees: <strong>{item.onboarding_in_month.total}</strong></div>
                                                            </div>
                                                        }
                                                    >
                                                        <span style={{ cursor: 'help', textDecoration: 'underline', color: '#007bff' }}>
                                                            {item.onboarding_in_month.total}
                                                        </span>
                                                    </CustomTooltip>
                                                    {item.onboarding_in_month.total > 0 && <EmployeeMonthlyDetailsTable sub_company={item.sub_company} month={item.month} year={item.year} type={"joined"} SUB_COMPANIES={SUB_COMPANIES} />}
                                                </td>
                                                <td className="align-center">
                                                    <CustomTooltip
                                                        position="top"
                                                        tooltipContent={
                                                            <div>
                                                                <div>Active Employees: <strong>{item.leaving_in_month.active}</strong></div>
                                                                <div>Inactive Employees: <strong>{item.leaving_in_month.inactive}</strong></div>
                                                                <div>Total Employees: <strong>{item.leaving_in_month.total}</strong></div>
                                                            </div>
                                                        }
                                                    >
                                                        <span style={{ cursor: 'help', textDecoration: 'underline', color: '#007bff' }}>
                                                            {item.leaving_in_month.total}
                                                        </span>
                                                    </CustomTooltip>
                                                    {item.leaving_in_month.total > 0 && <EmployeeMonthlyDetailsTable sub_company={item.sub_company} month={item.month} year={item.year} type={"exit"} SUB_COMPANIES={SUB_COMPANIES} />}
                                                </td>
                                                <td className="align-center">
                                                    <CustomTooltip
                                                        position="top"
                                                        tooltipContent={
                                                            <div>
                                                                <div>Active Employees: <strong>{item.end_of_month.active}</strong></div>
                                                                <div>Inactive Employees: <strong>{item.end_of_month.inactive}</strong></div>
                                                                <div>Total Employees: <strong>{item.end_of_month.total}</strong></div>
                                                            </div>
                                                        }
                                                    >
                                                        <span style={{ cursor: 'help', textDecoration: 'underline', color: '#007bff' }}>
                                                            {item.end_of_month.total}
                                                        </span>
                                                    </CustomTooltip>
                                                    {item.end_of_month.total > 0 && <EmployeeMonthlyDetailsTable sub_company={item.sub_company} month={item.month} year={item.year} type={"end_of_month"} SUB_COMPANIES={SUB_COMPANIES} />}
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                    {filteredHeadcountData?.length === 0 && (
                                        <tr className="custom-table-head-td">
                                            <td colSpan="7" className="align-center">
                                                No data available for the selected criteria
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            }
                        </table>
                    </div>
                </div>
            </div>
            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </>
    );
};

const EmployeeMonthlyDetailsTable = ({ sub_company, month, year, type, SUB_COMPANIES }) => {
    const [show, setShow] = useState(false);
    const [buffer, setBuffering] = useState(true);

    // State for filters
    const [selectedSubCompany, setSelectedSubCompany] = useState(sessionStorage.getItem("company_id"));
    const [selectedMonth, setSelectedMonth] = useState(month);
    const [selectedYear, setSelectedYear] = useState(year);
    const [selectedType, setSelectedType] = useState(type);
    const [selectedEmployeeStatus, setSelectedEmployeeStatus] = useState("null");

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
        getEmployeeMonthlyDetails();
    };

    const [employeeDetails, setEmployeeDetails] = useState({});
    const [employeeList, setEmployeeList] = useState([]);

    // Get employee monthly details from API
    const getEmployeeMonthlyDetails = async () => {
        setBuffering(true);
        try {
            const payload = {
                month: selectedMonth,
                year: selectedYear,
                type: selectedType
            };

            const res = await axios.post(
                `${BASE_URL}/wfm/monthly-report-employeedetail-bysubcompany-byempstatus/${sub_company}/${selectedEmployeeStatus}/`,
                payload
            );
            setEmployeeDetails(res.data);

            const sortedList = customSortByKey(res.data.employees, "emp_code");
            setEmployeeList(sortedList)
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false);
        }
    };


    const [searchQuery, setSearchQuery] = useState("");
    const handleSearchChange = (e) => {
        setSearchQuery(e.target.value);
    };


    const navigate = useNavigate();
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split('/');
    const url = urlParts[3];

    const Viewdetails = (emp_code, user_detail) => {
        navigate(`/${url}/userdetailscrud/${emp_code}/${user_detail}/`);
    };

    // Type options
    const typeOptions = [
        { key: 'joined', value: 'Onboarding' },
        { key: 'exit', value: 'Leaving' },
        { key: 'start_of_month', value: 'Start of Month' },
        { key: 'end_of_month', value: 'End of Month' }
    ];

    // Employee status options
    const employeeStatusOptions = [
        { value: 'null', label: 'All Status' },
        { value: 'active', label: 'Active' },
        { value: 'inactive', label: 'Inactive' }
    ];

    return (
        <>
            {/* <button
                className=""
                title="View Employee Monthly Details"
                style={{ paddingLeft: "5px", color: "blue", fontSize: "14px" }}
                onClick={handleShow}
            >
                View
            </button> */}
            <ButtonVariants
                buttonDisplay={'BlueEye-Name'}
                buttonDisplayName={'View'}
                buttonDisplayNameColor={'black'}
                buttonDisplayTitle={'View Employee Monthly Details'}
                handleShow={handleShow}
            />
            <Modal show={show} onHide={handleClose} dialogClassName="four-fifth-modal">
                <Modal.Body>
                    <div className="table-css-white-background">
                        <div className="table-heading-flex">
                            <div className="flex-column repo-heading font-weight500 font-size-heading">
                                <div>
                                    {employeeDetails?.month_year}
                                    {employeeDetails?.employee_status && employeeDetails.employee_status !== 'null' ? ` - ${employeeStatusOptions.find(status => status.value === employeeDetails.employee_status)?.label}` : ' - '}
                                    {typeOptions.find(option => option.key === selectedType)?.value} Employees
                                </div>
                                <div>Total : {employeeDetails?.total_employees}</div>
                            </div>
                            <div className="flex-row">
                                <div className="table-searchh">
                                    <div>
                                        <SearchBig />
                                    </div>
                                    <div>
                                        <input
                                            placeholder="Search"
                                            className="navbar-inputt font-weight400 font-size-text"
                                            value={searchQuery}
                                            onChange={handleSearchChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Filters Section */}
                        {/* <div className="field-cont" style={{ marginBottom: '20px', padding: '10px', backgroundColor: '#f8f9fa', borderRadius: '8px' }}>
                            <div className="field-cont-div">
                                <Office />
                                <select
                                    className="attendance-input-field width-12vw"
                                    value={selectedSubCompany}
                                    onChange={(e) => setSelectedSubCompany(e.target.value)}
                                >
                                    {SUB_COMPANIES?.sort((a, b) => a.title - b.title).map((i, index) => (
                                        <option key={i.id} value={i.id}>{i.title}</option>
                                    ))}
                                </select>
                                <hr className="field-cont-hr" />
                            </div>
                            <div className="field-cont-div">
                                <Filter />
                                <select
                                    className="attendance-input-field width-12vw"
                                    value={selectedEmployeeStatus}
                                    onChange={(e) => setSelectedEmployeeStatus(e.target.value)}
                                >
                                    {employeeStatusOptions.map(status => (
                                        <option key={status.value} value={status.value}>
                                            {status.label}
                                        </option>
                                    ))}
                                </select>
                                <hr className="field-cont-hr" />
                            </div>

                            <button
                                className="model-button font-weight500"
                                onClick={getEmployeeMonthlyDetails}
                                style={{ marginLeft: '10px' }}
                            >
                                Apply Filters
                            </button>
                        </div> */}
                        {buffer ?
                            // <div className="spinner"></div> 
                            <Loader container={true} />
                            :
                            <table className="table-css">
                                <thead>
                                    <tr className="custom-table-head-tr">
                                        <th className="align-left">S.No</th>
                                        <th className="align-center">Emp Code</th>
                                        <th className="align-center">Name</th>
                                        <th className="align-center">Employee Status</th>
                                        <th className="align-center">Joining Date</th>
                                        <th className="align-center">Last Working Date</th>
                                        <th className="align-center">Company</th>
                                        <th className="align-center">Employee View</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {employeeList
                                        ?.filter(employee =>
                                            employee.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                            employee.emp_code?.toString().includes(searchQuery.toLowerCase())
                                        )
                                        .sort((a, b) => a.emp_code - b.emp_code)
                                        .map((employee, employeeIndex) => (
                                            <React.Fragment key={employeeIndex}>
                                                <tr key={employeeIndex} className="custom-table-head-td">
                                                    <td className="align-left">{employeeIndex + 1}</td>
                                                    <td className="align-center">{employee.emp_code}</td>
                                                    <td className="align-center">{employee.name}</td>
                                                    <td className="align-center">
                                                        {/* <span
                                                            style={{
                                                                padding: '4px 8px',
                                                                borderRadius: '4px',
                                                                backgroundColor: employee.employee_status === 'active' ? '#d4edda' : '#f8d7da',
                                                                color: employee.employee_status === 'active' ? '#155724' : '#721c24'
                                                            }}
                                                        >
                                                            {employee.employee_status}
                                                        </span> */}
                                                        <button className={`text-capitalize priority-button ${employee.employee_status === 'active' ? 'color-tab-green' : 'color-tab-red'}`}>
                                                            {employee.employee_status}
                                                        </button>
                                                    </td>
                                                    <td className="align-center">{formatDate(employee.joining_date)}</td>
                                                    <td className="align-center">{employee.last_working_date ? formatDate(employee.last_working_date) : '-'}</td>
                                                    <td className="align-center">{employee.company_name}</td>
                                                    <td className="align-center">
                                                        <button
                                                            className="employee-edit"
                                                            onClick={() => Viewdetails(employee.emp_code, employee.user_detail)}
                                                            title="View Profile"
                                                        >
                                                            <Eye />
                                                        </button>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}


                                    {employeeList?.length === 0 && !buffer && (
                                        <tr className="custom-table-head-td">
                                            <td colSpan="8" className="align-center">
                                                No data available for the selected criteria
                                            </td>
                                        </tr>
                                    )}
                                </tbody>

                            </table>
                        }
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

export {
    ExpenseCustomReport,
    ImprestCustomReport,
    EmployeeHeadcountCustomReport,
    EmployeeMonthlyDetailsTable,
};